export default __webpack_public_path__ + "static/media/circle-money.8827a6a1.svg";